import { Link } from "react-router-dom";
import InputField from "../../components/form/input-field";
import GuestLayout from "../../components/layouts/guest";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import ApiRequest from "../../libs/ApiCall";
import { useState } from "react";
import { EmptyFormInput } from "../../libs/helper-support";
import Logo from "../../components/logo";

const ForgotPassword = () => {

    const [loading, setLoading] = useState<boolean>(false);
    
    const [processState, setProcessState] = useState<string|null>(null);
    
    const [message, setMessage] = useState<string>('');

    const formSchema = yup.object({
        email: yup.string().email().required('Email is required'),
    });

    const  {
        setValue,
        setError,
        formState: {errors},
        handleSubmit,
        getValues,
        reset,
    } = useForm({resolver: yupResolver(formSchema)}); 


    const forgotPassword = async (data:any) => {
        setLoading(true);
        
        const request :any = await ApiRequest({endpoint: 'auth/forgot-password', method: 'POST', payload: data});
        
        setLoading(false);
        
        if ( request.status === '200'){
            reset(EmptyFormInput(formSchema));
            setProcessState('success');
            setMessage('Password reset link has been sent to your email');
            return;
        }

        setProcessState('error');
        
        setMessage(request.message);

        if (request.status === "payloadValidationError") {
            for (const [field, messages] of Object.entries(request.data)) {
                const input_field : any = field ;
                const error_message : any = messages
                setError(input_field, { type: "manual", message: error_message.join(", ") });
            }
        }
    }
    return (
        <GuestLayout>
            <form onSubmit={handleSubmit(forgotPassword)} className="mx-auto rounded-[16px] page-outer lg:w-2/5">
                <div className="flex justify-center mb-5"><Logo/></div>
                <h1 className="text-center page-title">Reset your password</h1>
                <p className="text-light-black text-[14px] mt-8">Provide the email on your account and we’ll send details to reset your password</p>
                {processState && <div className={`${processState === 'success' ? 'text-green-500' : 'text-red-500'} text-[14px] my-2`}>{message}</div>}
                <div className="grid mt-6 gap-y-4">
                    <InputField
                        label="Email address"
                        placeholder="name@company.com"
                        type="email"
                        error={errors.email?.message}
                        value={getValues('email')}
                        onChangeInput={(e) => [setValue('email', e.target.value), setError('email', {message: ''})]}
                    />
                    <div className="flex justify-center">
                        <button disabled={loading} className={`${loading && 'opacity-[0.5]'} w-fit pryBtn`}>Reset Password</button>
                    </div>
                    <p className="text-center text-[14px] mt-5 flex space-x-1 justify-center">
                        <span>Remembered your password?</span>
                        <Link to={'/login'} className="text-[#0099CE] text-[14px] font-[600]">Return to Login</Link>
                    </p>
                </div>
            </form>
        </GuestLayout>
    );
}

export default ForgotPassword